// Helper: แปลง sub condition แต่ละอันให้เป็น expression clause
function transformSubCondition(sub) {
    // ดึงชื่อ attribute จาก resourceAttribute (ถ้าเป็น object ให้ใช้ .name)
    const attributeName =
        typeof sub.resourceAttribute === 'object' && sub.resourceAttribute.name
            ? sub.resourceAttribute.name
            : sub.resourceAttribute;

    const clause = {
        l_operand: { object_attr: attributeName },
        operator: sub.operator,
        r_operand: {}
    };

    // ตรวจสอบ value_property เพื่อกำหนด r_operand ตาม value_type
    if (sub.value_property.value_type === "Constant") {
        clause.r_operand = { const: sub.value_property.value };
    } else if (sub.value_property.value_type === "Subject") {
        clause.r_operand = { request_attr: `request.subject.${sub.value_property.value}` };
    } else if (sub.value_property.value_type === "Parameter") {
        clause.r_operand = { request_attr: `${sub?.value_property?.required ? "request.params.required." : "request.params."}${sub.value_property.value}` };
    }

    return clause;
}

function transformGroupConditions(conditions) {
    if (!conditions || conditions.length === 0) return null;

    const conjunctions_count = countConjunctions(conditions); // ["AND", "OR", null, "AND"]

    const expressions_count = conditions.map(cond => {
        return transformSubConditions(cond.subConditions); // [{l_operand: { object_attr: "name" }, operator: "==", r_operand: { const: "value" } }]
    });
    const expression_group = checkGroupExpression(expressions_count);

    if (checkConsistency(conjunctions_count)) { // ตรวจสอบว่าเป็น AND หรือ OR ทั้งหมดหรือไม่
        return {
            conjunction: conjunctions_count[0],
            group: false,
            condition: expression_group
        };
    } else {
        let currentConjunction = conjunctions_count[0];
        let exp = {
            conjunction: conjunctions_count[0],
            group: false,
            condition: [expression_group[0]]
        };
        let conditions_count = exp.condition;
        for (let i = 0; i < conjunctions_count.length; i++) {
            if (currentConjunction !== conjunctions_count[i]) { // กรณีที่ conjunction เปลี่ยน "AND" => "OR" หรือ "OR" => "AND"
                if (conjunctions_count[i] === null) {
                    return exp;
                } else {
                    currentConjunction = conjunctions_count[i];
                    conditions_count = [{ ...exp }];
                    conditions_count.push(expression_group[i + 1]);
                    exp = {
                        conjunction: conjunctions_count[i],
                        group: false,
                        condition: conditions_count
                    };
                }
            } else { // กรณีที่ conjunction เดิมยังคงอยู่
                conditions_count.push(expression_group[i + 1]);
                exp = {
                    conjunction: conjunctions_count[i],
                    group: false,
                    condition: conditions_count
                }
            }
        }
        return exp;
    }
}

function checkGroupExpression(expression) {
    const expression_checked = expression.map((exp) => {
        if (exp.condition && exp.condition.length > 1) {
            return { ...exp, group: true };
        } else {
            return exp;
        }
    });
    return expression_checked;
};

function transformSubConditions(subConditions) {
    if (!subConditions || subConditions.length === 0) return null;
    if (subConditions.length === 1) return transformSubCondition(subConditions[0]);

    const conjunctions_count = countConjunctions(subConditions); // ["AND", "OR", null, "AND"]
    // console.log("Count Conjunctions:", conjunctions_count);
    const expressions_count = countExpressions(subConditions); // [{l_operand: { object_attr: "name" }, operator: "==", r_operand: { const: "value" } }]
    // console.log("Count Expressions:", expressions_count);

    if (checkConsistency(conjunctions_count)) { // ตรวจสอบว่าเป็น AND หรือ OR ทั้งหมดหรือไม่
        return {
            conjunction: conjunctions_count[0],
            group: false,
            condition: expressions_count
        };
    } else {
        let currentConjunction = conjunctions_count[0];
        let exp = {
            conjunction: conjunctions_count[0],
            group: false,
            condition: [expressions_count[0]]
        };
        let conditions_count = exp.condition;
        for (let i = 0; i < conjunctions_count.length; i++) {
            if (currentConjunction !== conjunctions_count[i]) { // กรณีที่ conjunction เปลี่ยน "AND" => "OR" หรือ "OR" => "AND"
                if (conjunctions_count[i] === null) {
                    return exp;
                } else {
                    currentConjunction = conjunctions_count[i];
                    conditions_count = [{ ...exp }];
                    conditions_count.push(expressions_count[i + 1]);
                    exp = {
                        conjunction: conjunctions_count[i],
                        group: false,
                        condition: conditions_count
                    };
                }
            } else { // กรณีที่ conjunction เดิมยังคงอยู่
                conditions_count.push(expressions_count[i + 1]);
                exp = {
                    conjunction: conjunctions_count[i],
                    group: false,
                    condition: conditions_count
                }
            }
        }
        return exp;
    }
}

function countConjunctions(conditions) {
    const conjunctions = conditions.map(cond => {
        if (cond.conjunction === "") {
            return null;
        } else {
            return cond.conjunction;
        }
    });
    return conjunctions
}

function checkConsistency(arr) {
    const hasAND = arr.includes('AND');
    const hasOR = arr.includes('OR');
    return !(hasAND && hasOR);
}

function countExpressions(subConditions) {
    const expressions = subConditions.map(cond => {
        return transformSubCondition(cond);
    });
    return expressions
}

function transformConditionsToExpression(conditions) {
    if (!conditions || conditions.length === 0) return {};

    if (conditions.length === 1) {
        const expression = transformSubConditions(conditions[0].subConditions);
        // return { expression: transformSubConditions(conditions[0].subConditions) };
        return expression;
    } else {
        const transform_group_conditions = transformGroupConditions(conditions);
        return transform_group_conditions;
    }
}

export default transformConditionsToExpression;